import { Component, h, Host } from '@stencil/core';
import { theme } from '@eventstore-ui/theme';

/**
 * Displays Pending Member illustration.
 * @part illustration - The root svg of the illustration.
 */
@Component({
    tag: 'es-illustration-pending-member',
    styleUrl: 'pending-member.css',
    shadow: true,
})
export class EsIllustrationPendingMember {
    render() {
        const isDark = theme.isDark();

        return (
            <Host dark={isDark} light={!isDark}>
                {isDark ? this.renderDark() : this.renderLight()}
            </Host>
        );
    }

    renderLight() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 571.7 866.9"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <defs>
                    <linearGradient
                        id="pending_member_b"
                        x1="850.5"
                        x2="529.3"
                        y1="-61.1"
                        y2="361.7"
                        gradientTransform="matrix(1 0 0 -1 -363.3 662)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#bbdefb" />
                        <stop offset="1" stop-color="#fff" />
                    </linearGradient>
                    <linearGradient
                        id="pending_member_c"
                        x1="767.9"
                        x2="562.2"
                        y1="342.1"
                        y2="613"
                        href="#pending_member_b"
                    />
                    <linearGradient
                        id="pending_member_d"
                        x1="922.5"
                        x2="703.6"
                        y1="-128.6"
                        y2="159.6"
                        href="#pending_member_b"
                    />
                </defs>
                <path
                    fill="url(#pending_member_b)"
                    fill-rule="evenodd"
                    d="M406 396.8c-36.3-21-45.3-10-87.1-34.1s-50.8-45.4-87.1-66.4c-34.4-19.8-67.9-22.7-90.8-4.4l-99 55.4 68.2 81.1v7.4c0 35.6 23.4 78 52.2 94.6l65.3 37.7L402.5 776l106.2-60.4c11.6-5.1 19-18.8 19-38.8v-60.2c0-32-7.9-66.2-21.4-98.8-22.5-54.3-60.9-98.2-100.3-121Z"
                />
                <path
                    fill="url(#pending_member_c)"
                    fill-rule="evenodd"
                    d="M318.9 18.7c-34.6-20-65.8-20.2-88-4.3L128.8 72l165.6 316.1L402.5 327c23.5-13.9 38.2-44.4 38.2-87.5 0-83.2-54.5-182-121.8-220.8Z"
                />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M211.7 380.8c67.3 38.8 121.8 2.9 121.8-80.3S279 118.5 211.7 79.7C144.4 40.9 89.9 76.8 89.9 160s54.5 182 121.8 220.8Zm87.1 77.2c-36.3-21-45.3-10-87.1-34.1s-50.8-45.4-87.1-66.4c-39.5-22.8-77.8-23.2-100.3 5.1C10.8 379.6 3 404.7 3 436.7v60.2c0 35.6 23.4 78 52.2 94.6l313.1 180.7c28.8 16.6 52.2 1.2 52.2-34.4v-60.2c0-32-7.8-66.2-21.3-98.7-22.5-54.2-60.9-98.1-100.4-120.9Z"
                />
                <path
                    fill="#1a4e85"
                    d="m156.3 382.6 2.3-2c-9.4-8.3-19.2-16.4-33.2-24.5-16.9-9.8-33.3-15.3-48.1-16.5v3c14.4 1.3 30.2 6.6 46.6 16.1 11.6 6.8 22.5 14.8 32.4 23.9ZM258.2 443.9c11.6 2.8 22.5 5.4 39.8 15.4 36.8 21.3 70.6 59.7 92.7 104.7l3.1-.6c-22.3-45.8-56.7-85-94.2-106.7-17.7-10.2-28.9-12.9-40.6-15.7s-25-6-46.4-18.4c-8.9-5.1-17.4-10.8-25.4-17.1l-1.5 2.3v.3c8.1 6.3 16.6 12 25.4 17.1 21.7 12.5 34.6 15.6 47.1 18.7Z"
                />
                <path
                    fill="url(#pending_member_d)"
                    fill-rule="evenodd"
                    d="M531.1 818.6c25.1-18.6 37.6-51.5 37.6-98.8s-12.5-94.6-37.6-142.1c-17.9-33.9-38.6-61-61.9-81.3l-30.8-21.8c-35.1-19.8-65-20.6-89.7-2.3l-1 .8-46.3 26.6 13.7 29.6c-2.8 13.8-4.2 27.8-4 41.8v7.2l137.7 242 1.8.9 6.1 13 12.1 21.2 48.9-29c4.7-2.1 9.2-4.7 13.3-7.8Z"
                />
                <path
                    fill="#1a4e85"
                    d="m327.6 337.6 2.8 1c3.1-12.4 4.6-25.2 4.5-38 0-47.1-17.5-99.2-44.8-142.8l-2.2 2c26.9 43 44 94.4 44 140.8.2 12.5-1.3 24.9-4.3 37ZM293.1 387.6c-22 12.1-50.6 9.3-80.6-8-23.7-13.7-45.7-34.8-64.4-60.2h-.4l-.5.2-1.9 1c19 25.9 41.5 47.6 65.6 61.5 18.3 10.5 36.1 15.9 52.3 15.9 10.7.1 21.3-2.5 30.7-7.5-.1-1-.4-2-.8-2.9ZM209.5 80.2c.6-.8 1.3-1.6 2-2.3-16.6-9.4-32.8-14.5-47.7-15.2l.6 3c14.1.8 29.4 5.7 45.1 14.5ZM419 737.9c0 5-.5 10-1.6 14.9l2.9.5c1.2-5.1 1.7-10.2 1.7-15.4v-60.2c0-8-.5-16-1.4-23.9l-2.9.7c.9 7.7 1.3 15.4 1.3 23.2v60.2ZM514.5 544.7l2.7-1.3c-2.7-8.7-5.9-17.4-9.5-26.1-21.6-52.2-59.4-97.7-101-121.7l-.7-.4c-5.2-3-10.6-5.7-16.2-8-.2 1-.4 2-.7 3 5.5 2.4 10.9 5.1 16.1 8.1l.4.2c40.9 23.8 78 68.6 99.3 120 3.7 8.7 6.8 17.4 9.6 26.2ZM366.1 379.8c-9.6-2.3-19.5-4.7-33.6-11.5l36.1-20.4a5.1 5.1 0 0 1-1.4-2.6l-41.1 23.2 2.5 1.3c15.7 8 26.4 10.5 36.8 13l6.7 1.7c.4-1 .9-1.9 1.5-2.7-2.6-.8-5-1.4-7.5-2ZM309.1 512.9l-5.9-12.6 45.2-25.9.5-.4.6-.5c24.4-18.1 54.5-17 89.5 3.2 19 11 36.6 25.9 52.6 44.7l2.2-2.1c-16.2-19-34-34.1-53.3-45.2-36.1-20.8-67.4-21.9-92.8-3l-.6.5-47.8 27.5 7.1 15.2c.9-.4 1.8-.9 2.7-1.4Z"
                />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M255.8 603.2c0 47.3 12.6 94.6 37.6 142.2s55.5 81.6 91.2 102.2 66.2 21.7 91.3 3.1 37.5-51.5 37.5-98.7-12.5-94.6-37.5-142.1-55.5-81.6-91.3-102.3-66.1-21.7-91.2-3.1c-25.1 18.6-37.6 51.5-37.6 98.7Z"
                />
                <path
                    fill="#1a4e85"
                    d="m511.8 742.5 3-.2c-1.6-44.1-14.3-88.8-37.6-133.1-25.1-47.6-56-82.2-91.8-102.9-16-9.2-30.9-14.5-44.9-16v3c13.5 1.5 28 6.7 43.5 15.6 35.4 20.4 65.9 54.6 90.6 101.7 23.2 43.9 35.7 88.2 37.3 131.9ZM267.8 677.9c-6.8-24.3-10.4-49.4-10.5-74.7 0-46.5 12.5-79.3 37-97.5 4.5-3.4 9.5-6.2 14.7-8.3l.4-.2.7-.3 2.8-1.5.5-.4.7-.6.8-.6.8-.5.6-.6c-.2-.3-.3-.5-.4-.8-8.5 2.3-16.4 6.1-23.4 11.4-25.3 18.8-38.2 52.4-38.2 99.9 0 25.5 3.7 50.8 10.6 75.3 1-.2 1.9-.5 2.9-.6ZM437.6 727.5c-1.9-.1-3.8-.7-5.4-1.8l-53.7-31c-6.4-3.7-9.7-9.9-9.7-18.3v-89.7c0-4.8 1.1-7.8 3.3-9.1s4.6-.7 7.9 1.2l10.8 6.2c6.4 3.7 9.7 9.8 9.7 18.2v62.9l33.2 19.2c6.4 3.7 9.7 9.9 9.7 18.3v14.2c0 4.8-1.1 7.8-3.3 9-.7.5-1.6.7-2.5.7ZM374.7 580l-1.1.2c-1.1.7-1.8 3-1.8 6.5v89.7c0 7.4 2.7 12.5 8.2 15.7l53.7 31c1.6.9 3.7 1.8 4.9 1.1s1.8-2.9 1.8-6.4v-14.2c0-7.4-2.7-12.5-8.2-15.7l-34.7-20v-64.7c0-7.3-2.7-12.4-8.2-15.6l-10.8-6.2c-1.1-.8-2.4-1.3-3.8-1.4Z"
                />
                <path
                    id="pending_member_e"
                    fill="none"
                    stroke="#1a4e85"
                    stroke-miterlimit="10"
                    stroke-width="6"
                    d="M531.1 577.7c-3.7-7-7.5-13.7-11.4-20.2-3.6-13.5-8.1-26.8-13.4-39.7-22.5-54.3-60.9-98.2-100.3-121-33.1-19.1-43.5-11.7-76.7-28.4l73.2-41.4c23.5-13.9 38.2-44.4 38.2-87.5 0-83.2-54.5-182-121.8-220.8-34.6-20-65.8-20.2-88-4.3L128.8 72h.1c-24 13.7-39 44.3-39 87.9s16.1 95 41.5 137.2L42 347.2l.2.2c-6.9 3.8-13 8.9-17.9 15.1C10.8 379.5 3 404.6 3 436.6v60.2c0 35.6 23.4 78 52.2 94.6l227.2 131.2c3.3 7.6 7 15.2 11 22.8 25 47.5 55.4 81.6 91.2 102.2 31.7 18.3 59.2 21.2 82.5 8.7v.2l50.7-30.1c4.7-2.1 9.2-4.7 13.3-7.8 25.1-18.6 37.6-51.5 37.6-98.8s-12.5-94.6-37.6-142.1Z"
                />
            </svg>
        );
    }

    renderDark() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 571.7 866.9"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <defs>
                    <linearGradient
                        id="pending_member_b"
                        x1="850.5"
                        x2="529.3"
                        y1="-61.1"
                        y2="361.7"
                        gradientTransform="matrix(1 0 0 -1 -363.3 662)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#09264a" />
                        <stop offset=".1" stop-color="#112d50" />
                        <stop offset=".3" stop-color="#2a4362" />
                        <stop offset=".5" stop-color="#52667f" />
                        <stop offset=".7" stop-color="#8997a8" />
                        <stop offset="1" stop-color="#ced4db" />
                    </linearGradient>
                    <linearGradient
                        id="pending_member_c"
                        x1="767.9"
                        x2="562.2"
                        y1="342.1"
                        y2="613"
                        gradientTransform="matrix(1 0 0 -1 -363.3 662)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#09264a" />
                        <stop offset=".1" stop-color="#112d50" />
                        <stop offset=".3" stop-color="#2a4362" />
                        <stop offset=".5" stop-color="#52667f" />
                        <stop offset=".7" stop-color="#8997a8" />
                        <stop offset="1" stop-color="#ced4db" />
                    </linearGradient>
                    <linearGradient
                        id="pending_member_d"
                        x1="922.5"
                        x2="703.6"
                        y1="-128.6"
                        y2="159.6"
                        gradientTransform="matrix(1 0 0 -1 -363.3 662)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#09264a" />
                        <stop offset=".1" stop-color="#112d50" />
                        <stop offset=".3" stop-color="#2a4362" />
                        <stop offset=".5" stop-color="#52667f" />
                        <stop offset=".7" stop-color="#8997a8" />
                        <stop offset="1" stop-color="#ced4db" />
                    </linearGradient>
                </defs>
                <path
                    fill="url(#pending_member_b)"
                    fill-rule="evenodd"
                    d="M406 396.8c-36.3-21-45.3-10-87.1-34.1s-50.8-45.4-87.1-66.4c-34.4-19.8-67.9-22.7-90.8-4.4l-99 55.4 68.2 81.1v7.4c0 35.6 23.4 78 52.2 94.6l65.3 37.7L402.5 776l106.2-60.4c11.6-5.1 19-18.8 19-38.8v-60.2c0-32-7.9-66.2-21.4-98.8-22.5-54.3-60.9-98.2-100.3-121Z"
                />
                <path
                    fill="url(#pending_member_c)"
                    fill-rule="evenodd"
                    d="M318.9 18.7c-34.6-20-65.8-20.2-88-4.3L128.8 72l165.6 316.1L402.5 327c23.5-13.9 38.2-44.4 38.2-87.5 0-83.2-54.5-182-121.8-220.8Z"
                />
                <path
                    fill="#ced4db"
                    fill-rule="evenodd"
                    d="M211.7 380.8c67.3 38.8 121.8 2.9 121.8-80.3S279 118.5 211.7 79.7C144.4 40.9 89.9 76.8 89.9 160s54.5 182 121.8 220.8Zm87.1 77.2c-36.3-21-45.3-10-87.1-34.1s-50.8-45.4-87.1-66.4c-39.5-22.8-77.8-23.2-100.3 5.1C10.8 379.6 3 404.7 3 436.7v60.2c0 35.6 23.4 78 52.2 94.6l313.1 180.7c28.8 16.6 52.2 1.2 52.2-34.4v-60.2c0-32-7.8-66.2-21.3-98.7-22.5-54.2-60.9-98.1-100.4-120.9Z"
                />
                <path
                    fill="#09264a"
                    d="m156.3 382.6 2.3-2c-9.4-8.3-19.2-16.4-33.2-24.5-16.9-9.8-33.3-15.3-48.1-16.5v3c14.4 1.3 30.2 6.6 46.6 16.1 11.6 6.8 22.5 14.8 32.4 23.9ZM258.2 443.9c11.6 2.8 22.5 5.4 39.8 15.4 36.8 21.3 70.6 59.7 92.7 104.7l3.1-.6c-22.3-45.8-56.7-85-94.2-106.7-17.7-10.2-28.9-12.9-40.6-15.7s-25-6-46.4-18.4c-8.9-5.1-17.4-10.8-25.4-17.1l-1.5 2.3v.3c8.1 6.3 16.6 12 25.4 17.1 21.7 12.5 34.6 15.6 47.1 18.7Z"
                />
                <path
                    fill="url(#pending_member_d)"
                    fill-rule="evenodd"
                    d="M531.1 818.6c25.1-18.6 37.6-51.5 37.6-98.8s-12.5-94.6-37.6-142.1c-17.9-33.9-38.6-61-61.9-81.3l-30.8-21.8c-35.1-19.8-65-20.6-89.7-2.3l-1 .8-46.3 26.6 13.7 29.6c-2.8 13.8-4.2 27.8-4 41.8v7.2l137.7 242 1.8.9 6.1 13 12.1 21.2 48.9-29c4.7-2.1 9.2-4.7 13.3-7.8Z"
                />
                <path
                    fill="#09264a"
                    d="m327.6 337.6 2.8 1c3.1-12.4 4.6-25.2 4.5-38 0-47.1-17.5-99.2-44.8-142.8l-2.2 2c26.9 43 44 94.4 44 140.8.2 12.5-1.3 24.9-4.3 37ZM293.1 387.6c-22 12.1-50.6 9.3-80.6-8-23.7-13.7-45.7-34.8-64.4-60.2h-.4l-.5.2-1.9 1c19 25.9 41.5 47.6 65.6 61.5 18.3 10.5 36.1 15.9 52.3 15.9 10.7.1 21.3-2.5 30.7-7.5-.1-1-.4-2-.8-2.9ZM209.5 80.2c.6-.8 1.3-1.6 2-2.3-16.6-9.4-32.8-14.5-47.7-15.2l.6 3c14.1.8 29.4 5.7 45.1 14.5ZM419 737.9c0 5-.5 10-1.6 14.9l2.9.5c1.2-5.1 1.7-10.2 1.7-15.4v-60.2c0-8-.5-16-1.4-23.9l-2.9.7c.9 7.7 1.3 15.4 1.3 23.2v60.2ZM514.5 544.7l2.7-1.3c-2.7-8.7-5.9-17.4-9.5-26.1-21.6-52.2-59.4-97.7-101-121.7l-.7-.4c-5.2-3-10.6-5.7-16.2-8-.2 1-.4 2-.7 3 5.5 2.4 10.9 5.1 16.1 8.1l.4.2c40.9 23.8 78 68.6 99.3 120 3.7 8.7 6.8 17.4 9.6 26.2ZM366.1 379.8c-9.6-2.3-19.5-4.7-33.6-11.5l36.1-20.4a5.1 5.1 0 0 1-1.4-2.6l-41.1 23.2 2.5 1.3c15.7 8 26.4 10.5 36.8 13l6.7 1.7c.4-1 .9-1.9 1.5-2.7-2.6-.8-5-1.4-7.5-2ZM309.1 512.9l-5.9-12.6 45.2-25.9.5-.4.6-.5c24.4-18.1 54.5-17 89.5 3.2 19 11 36.6 25.9 52.6 44.7l2.2-2.1c-16.2-19-34-34.1-53.3-45.2-36.1-20.8-67.4-21.9-92.8-3l-.6.5-47.8 27.5 7.1 15.2c.9-.4 1.8-.9 2.7-1.4Z"
                />
                <path
                    fill="#ced4db"
                    fill-rule="evenodd"
                    d="M255.8 603.2c0 47.3 12.6 94.6 37.6 142.2s55.5 81.6 91.2 102.2 66.2 21.7 91.3 3.1 37.5-51.5 37.5-98.7-12.5-94.6-37.5-142.1-55.5-81.6-91.3-102.3-66.1-21.7-91.2-3.1c-25.1 18.6-37.6 51.5-37.6 98.7Z"
                />
                <path
                    fill="#09264a"
                    d="m511.8 742.5 3-.2c-1.6-44.1-14.3-88.8-37.6-133.1-25.1-47.6-56-82.2-91.8-102.9-16-9.2-30.9-14.5-44.9-16v3c13.5 1.5 28 6.7 43.5 15.6 35.4 20.4 65.9 54.6 90.6 101.7 23.2 43.9 35.7 88.2 37.3 131.9ZM267.8 677.9c-6.8-24.3-10.4-49.4-10.5-74.7 0-46.5 12.5-79.3 37-97.5 4.5-3.4 9.5-6.2 14.7-8.3l.4-.2.7-.3 2.8-1.5.5-.4.7-.6.8-.6.8-.5.6-.6c-.2-.3-.3-.5-.4-.8-8.5 2.3-16.4 6.1-23.4 11.4-25.3 18.8-38.2 52.4-38.2 99.9 0 25.5 3.7 50.8 10.6 75.3 1-.2 1.9-.5 2.9-.6ZM437.6 727.5c-1.9-.1-3.8-.7-5.4-1.8l-53.7-31c-6.4-3.7-9.7-9.9-9.7-18.3v-89.7c0-4.8 1.1-7.8 3.3-9.1s4.6-.7 7.9 1.2l10.8 6.2c6.4 3.7 9.7 9.8 9.7 18.2v62.9l33.2 19.2c6.4 3.7 9.7 9.9 9.7 18.3v14.2c0 4.8-1.1 7.8-3.3 9-.7.5-1.6.7-2.5.7ZM374.7 580l-1.1.2c-1.1.7-1.8 3-1.8 6.5v89.7c0 7.4 2.7 12.5 8.2 15.7l53.7 31c1.6.9 3.7 1.8 4.9 1.1s1.8-2.9 1.8-6.4v-14.2c0-7.4-2.7-12.5-8.2-15.7l-34.7-20v-64.7c0-7.3-2.7-12.4-8.2-15.6l-10.8-6.2c-1.1-.8-2.4-1.3-3.8-1.4Z"
                />
                <path
                    id="pending_member_e"
                    fill="none"
                    stroke="#fff"
                    stroke-miterlimit="10"
                    stroke-width="6"
                    d="M531.1 577.7c-3.7-7-7.5-13.7-11.4-20.2-3.6-13.5-8.1-26.8-13.4-39.7-22.5-54.3-60.9-98.2-100.3-121-33.1-19.1-43.5-11.7-76.7-28.4l73.2-41.4c23.5-13.9 38.2-44.4 38.2-87.5 0-83.2-54.5-182-121.8-220.8-34.6-20-65.8-20.2-88-4.3L128.8 72h.1c-24 13.7-39 44.3-39 87.9s16.1 95 41.5 137.2L42 347.2l.2.2c-6.9 3.8-13 8.9-17.9 15.1C10.8 379.5 3 404.6 3 436.6v60.2c0 35.6 23.4 78 52.2 94.6l227.2 131.2c3.3 7.6 7 15.2 11 22.8 25 47.5 55.4 81.6 91.2 102.2 31.7 18.3 59.2 21.2 82.5 8.7v.2l50.7-30.1c4.7-2.1 9.2-4.7 13.3-7.8 25.1-18.6 37.6-51.5 37.6-98.8s-12.5-94.6-37.6-142.1Z"
                />
            </svg>
        );
    }
}
